import { EventType } from '@/stores/types';
import Events from '../index';

const Archive = (): JSX.Element => {
  return <Events eventType={EventType.ARCHIVE} placeholder='No events have been processed for this store yet.' />;
};

export default Archive;
